<template>
  <a @click="toggleNavbar" class="nav-link sidebartoggler d-none d-md-block text-muted waves-effect waves-dark" href="javascript:void(0)"><i class="ti-menu"></i></a>
</template>


<script>
    export default {
        mounted() {
        },

        data()  {
          return {
            hidden: false
          }
        },

        methods: {
          toggleNavbar: function() {
            if (this.hidden) {
                document.getElementsByClassName("left-sidebar")[0].setAttribute("style", "display: block");
                document.getElementsByClassName("page-wrapper")[0].setAttribute("style", "margin-left: 240px");
            } else {
                document.getElementsByClassName("left-sidebar")[0].setAttribute("style", "display: none");
                document.getElementsByClassName("page-wrapper")[0].setAttribute("style", "margin-left: 0");
            }
            this.hidden = !this.hidden

          }
        }
    }
</script>
